import React, { ReactNode } from 'react';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';

// Define your custom palette
const theme = createTheme({
    palette: {
        background: {
            default: '#f0f0f0',
        },
        primary: {
            main: '#191919',
        },
        secondary: {
            main: '#f3c920',
        },
    },
});

// Wraps the app in ThemeProvider + CssBaseline
interface AppThemeProviderProps {
    children: ReactNode;
}

export const AppThemeProvider: React.FC<AppThemeProviderProps> = ({
    children,
}) => (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
    </ThemeProvider>
);

export default theme;
